import { createAction } from '@reduxjs/toolkit';

import { moduleName } from './constants';

export const ROUTE_FEATURE_FLAGS = createAction(
  `${moduleName}/ROUTE_FEATURE_FLAGS`,
);
